<template>
  <div class="policy-card">
    <div class="policy-card__panel d-flex flex-column">
      <div class="row w-100 mb-3">
        <div class="col-12 d-flex align-items-center justify-content-between">
          <h6 class="mb-0 text-gray-700">ДГПО ВТС +</h6>
          <span
            v-if="removable"
            class="delete-item"
            role="button"
            tabindex="0"
            @click="removeDgpo"
            @keydown.enter.prevent="removeDgpo"
          >
            <i class="ki-outline ki-cross-square fs-2"></i>
          </span>
        </div>
      </div>
      <div class="row w-100">
        <div class="col-md-6 px-2">
          <select-field v-model="sumValue"
            id="dgpo.sum"
            name="dgpo_sum"
            :options="sumOptions"
            :required="true"
            :disabled="false"
            placeholder="Сумма"
            mb="5"
          />
        </div>
        <div class="col-md-6 px-2">
          <select-field v-model="avValue"
            id="dgpo.av"
            name="dgpo_av"
            :options="avOptions"
            :required="false"
            :disabled="false"
            placeholder="АВ"
            mb="5"
          />
        </div>
        <div class="col-12 px-2">
          <div class="custom-select dynamic">
            <label for="dgpo.agent">Агент</label>
            <v-select
              v-model="agentValue"
              input-id="dgpo.agent"
              :options="agentsOptions"
              :disabled="false"
              :reduce="item => item.id"
              :required="false"
              placeholder="Выберите..."
              class="mb-3 bg-gray-100 form rounded"
              label="name"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectField from '@/components/Fields/SelectField'
import vSelect from 'vue-select'

export default {
  components: {
    SelectField,
    vSelect,
  },
  name: 'DgpoBpmCard',
  emits: ['update:dgpo'],
  props: {
    dgpo: {
      type: Object,
      required: true,
    },
    mode: {
      type: Object,
      required: true,
    },
    module: {
      type: Object,
      required: true,
    },
    agentsDictionary: {
      type: Array,
      required: true,
    },
    removable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sumValue: {
      get() {
        return this.dgpo?.sum ?? null
      },
      set(value) {
        this.emitUpdate({ sum: value })
      },
    },
    avValue: {
      get() {
        return this.dgpo?.av ?? null
      },
      set(value) {
        this.emitUpdate({ av: value })
      },
    },
    agentValue: {
      get() {
        return this.dgpo?.agent ?? null
      },
      set(value) {
        this.emitUpdate({ agent: value })
      },
    },
    sumOptions() {
      const dict = this.module?.Dgpo?.sumDictionary?.()
      return this.dictionaryArrayToOptions(dict)
    },
    avOptions() {
      const dict = this.module?.Dgpo?.avDictionary?.()
      if (!this.dgpo?.agent) return { 0: '0%' }
      return this.dictionaryArrayToOptions(dict)
 
    },
    agentsOptions() {
      return this.agentsDictionary
    },
  },
  methods: {
    removeDgpo() {
      this.$emit('update:dgpo', null)
    },
    emitUpdate(patch) {
      const next = { ...(this.dgpo || {}), ...(patch || {}) }
      this.$emit('update:dgpo', next)
    },
    dictionaryArrayToOptions(dict) {
      const list = Array.isArray(dict) ? dict : []
      return list.reduce((acc, item) => {
        if (!item) return acc
        acc[item.value] = item.text
        return acc
      }, {})
    },
  },
}
</script>
